const MAX_VISIBLE = 20;

export default function keywordCombobox(available = []) {
    return {
        open: false,
        active: 0,
        query: '',
        all: Array.isArray(available) ? [...available] : [],

        init() {
            this.query = (this.$wire?.newKeyword ?? '').toString();

            this.$watch('$wire.newKeyword', (value) => {
                const next = (value ?? '').toString();

                // Server cleared the field after add/cancel — keep local filter in sync.
                if (next === '') {
                    this.query = '';
                }
            });
        },

        get filter() {
            return this.query;
        },

        get matches() {
            const term = this.filter.trim().toLowerCase();
            if (term === '') {
                return this.all;
            }
            return this.all.filter((kw) => kw.toLowerCase().includes(term));
        },

        get totalMatches() {
            return this.matches.length;
        },

        get filtered() {
            const list = this.matches.slice(0, MAX_VISIBLE);
            if (this.active >= list.length) {
                this.active = list.length === 0 ? 0 : list.length - 1;
            }
            return list;
        },

        onInput(event) {
            this.query = event.target?.value ?? '';
            this.active = 0;
            this.open = true;
        },

        onFocus() {
            this.open = true;
        },

        /**
         * Only close when focus actually left the combobox. Drag-selecting text and
         * releasing the mouse outside used to fire click.outside while the input
         * still had focus, which hid results until blur/refocus.
         */
        onClickOutside() {
            queueMicrotask(() => {
                if (!this.$el.contains(document.activeElement)) {
                    this.open = false;
                }
            });
        },

        moveActive(delta) {
            const len = this.filtered.length;
            if (len === 0) {
                return;
            }
            this.open = true;
            this.active = (this.active + delta + len) % len;
        },

        selectExisting(name) {
            this.query = name;
            this.$wire.set('newKeyword', name, false);
            this.open = false;
            this.active = 0;
        },

        commit() {
            this.$wire.set('newKeyword', this.query, false);
            this.$wire.call('addKeyword');
            this.open = false;
            this.active = 0;
            this.query = '';
        },
    };
}
